module.exports = __webpack_public_path__ + "static/media/marijuana.adcbdaf3.svg";